import { ActionIcon, Group, Text } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import TransactionResponse from "components/common/transaction/TransactionResponse";
import { TERM_DEPOSIT_STATUS } from "pages/term-deposit/constants/constants";
import { REFUND, REFUSE, SUCCESS } from "pages/term-deposit/images";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

const TermLoanSettlementResponse = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Lấy tham số từ URL
  const [searchParams] = useSearchParams();
  const type = searchParams.get("q") ?? TERM_DEPOSIT_STATUS.SUCCESS;

  // Chọn hình ảnh và thông điệp dựa trên type

  const sampleInfo = [
    { label: t("REFERENCE_CODE"), value: "DF330035253231" },
    { label: t("CUSTOMER_NAME"), value: "NGUYEN VAN A" },
    { label: t("ID_CARD_/_CITIZEN_ID"), value: "097097112233" },
    { label: t("LOAN_PURPOSE"), value: `${t("MOCK_CONSUMPTION")}` },
    { label: t("LOAN_AMOUNT"), value: "100,000,000 VND" },
    // VersionEn: dòng gốc ở dạng Unicode NFD (dấu tách rời) nên phải đọc từ file để thay,
    // gõ tay dạng NFC sẽ không khớp. Giá trị đưa vào từ điển ghi ở dạng NFC — tương đương
    // chuẩn hoá, render ra y hệt.
    { label: t("LOAN_TERM"), value: `${t("MOCK_6_MONTHS_10_PER_YEAR")}` },
    {
      label: t("INTEREST_CALCULATION_METHOD"),
      value: `${t("MOCK_REVOLVING_INTEREST_TO_PRINCIPAL")}`,
    },
  ];

  // Các thông tin hiển thị theo trạng thái
  const content: Record<
    "SUCCESS" | "REFUND" | "REFUSE",
    { image: string; message: string }
  > = {
    SUCCESS: {
      image: SUCCESS,
      message: t("APPROVED_DEPOSIT_SETTLEMENT"),
    },
    REFUND: {
      image: REFUND,
      message: t("REFUNDABLE_DEPOSIT"),
    },
    REFUSE: {
      image: REFUSE,
      message: t("DEPOSIT_PAYMENT_REJECTED"),
    },
  };

  const { image, message } =
    content[type as keyof typeof content] ?? content.SUCCESS;

  return (
    <>
      <Group
        mt="sm"
        sx={{
          display: "flex",
          gap: "8px",
          height: "40px",
          alignItems: "center",
        }}
      >
        <ActionIcon variant="transparent" onClick={() => navigate(-1)}>
          <IconArrowLeft size={24} stroke={1.5} color="black" />
        </ActionIcon>
        <Text fw={700} fz="lg">
          {t("OPEN_A_TERM_DEPOSIT_ACCOUNT")}
        </Text>
      </Group>
      <TransactionResponse
        image={image}
        message={message}
        amount={1500000}
        info={sampleInfo}
      />
    </>
  );
};

export default TermLoanSettlementResponse;
